import { logEvent } from "@src/appV2/lib/analytics";
import { APP_V2_USER_EVENTS } from "@src/appV2/lib/analytics/events";
import { WorkerQuizResultStatus } from "@src/appV2/OpenShifts/ShiftAction/types";
import { generatePath, useHistory } from "react-router-dom";

import { Button } from "../../components/Button";
import { WORKPLACE_QUIZ_RULES_PATH_FULL } from "../../WorkplaceQuiz/paths";
import { ShiftBottomSheetBookabilityCriteriaCard } from "./BookabilityCriteriaCard";

interface ShiftBottomSheetQuizCardProps {
  shiftId: string;
  quizResultStatus?: WorkerQuizResultStatus;
}

function getTitle(quizResultStatus?: WorkerQuizResultStatus) {
  if (quizResultStatus === WorkerQuizResultStatus.TOOK_LATEST_QUIZ_A_MONTH_AGO) {
    return "Refresh your understanding of this workplace's rules";
  }

  if (quizResultStatus === WorkerQuizResultStatus.TOOK_A_QUIZ_IN_PAST) {
    return "This workplace's rules have changed";
  }

  return "Take the quiz on this workplace's rules";
}

export function ShiftBottomSheetQuizCard(props: ShiftBottomSheetQuizCardProps) {
  const { shiftId, quizResultStatus } = props;
  const history = useHistory();

  return (
    <ShiftBottomSheetBookabilityCriteriaCard
      title={getTitle(quizResultStatus)}
      description="Please take a quiz to demonstrate your understanding of the rules at this workplace before you can book this shift."
      illustrationType="quiz-required"
      footer={
        <Button
          fullWidth
          variant="contained"
          size="medium"
          onClick={() => {
            logEvent(APP_V2_USER_EVENTS.SHIFT_DETAILS_CTA_START_QUIZ, {
              shiftId,
            });

            history.push(generatePath(WORKPLACE_QUIZ_RULES_PATH_FULL, { shiftId }));
          }}
        >
          Start Quiz (3 min)
        </Button>
      }
    />
  );
}
